import PropTypes from 'prop-types';
import React from 'react';
import _ from 'lodash';
import { Expandable } from '@unite-us/ui';
import { isFocused, INSURANCE } from 'common/utils/isFocused';
import PaymentsInformation from 'src/components/Insurance/PaymentsInformation';
import featureFlag from 'common/utils/FeatureFlag/FeatureFlag';
import ReactFinalFormBridge from 'common/form/ReactFinalFormBridge';
import MilitaryInformation from './MilitaryInformation';

export const SupplementalInformation = ({
  contactId,
  fields,
  currentGroup,
  registerField,
  untouch,
  initialValues = {},
}) => {
  const showHealthInsuranceSection = isFocused(currentGroup, INSURANCE);

  // Extract military values from initialValues instead of Redux Form fields
  const getMilitaryValues = () => {
    const values = {};
    MilitaryInformation.fields.forEach((fieldName) => {
      const value = _.get(initialValues, fieldName);
      if (value !== undefined) {
        _.set(values, fieldName, value);
      }
    });
    return values;
  };

  const militaryValues = getMilitaryValues();

  return (
    <Expandable
      className="supplemental-information"
      header="Supplemental Information"
    >
      {
         showHealthInsuranceSection && (
         <div className="payments-insurance payments-insurance-form">
           <h3 className="payments-insurance__header mb-3">Insurance Information</h3>
           <div className="health-insurance__content">
             <PaymentsInformation
               contactId={contactId || ''}
               fields={fields}
               registerField={registerField}
               untouch={untouch}
             />
           </div>
         </div>
         )
      }
      <ReactFinalFormBridge
        initialValues={militaryValues}
      >
        <MilitaryInformation />
      </ReactFinalFormBridge>
    </Expandable>
  );
};

SupplementalInformation.propTypes = {
  contactId: PropTypes.string,
  currentGroup: PropTypes.object.isRequired,
  fields: PropTypes.object.isRequired,
  registerField: PropTypes.func.isRequired,
  untouch: PropTypes.func.isRequired,
  initialValues: PropTypes.object,
};

SupplementalInformation.defaultProps = {
  contactId: '',
  initialValues: {},
};

export default featureFlag(SupplementalInformation);
